import { en } from './en'
import { fr } from './fr'

export const integrationsPage = { en, fr }
